import {
    GET_SIZE_CURVE_REPORT_REQUEST,
    GET_SIZE_CURVE_REPORT_SUCCESS,
    GET_SIZE_CURVE_REPORT_ERROR
} from "../actions/types";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";
const axios = require("axios");

export const getSizeCurveReport = (token, data, status, ptStatus) => (dispatch) => {
    console.log("status", ptStatus)
    dispatch({ type: GET_SIZE_CURVE_REPORT_REQUEST });

    return axios({
        method: "POST",
        url: `${BASEURL}getAll/SizeCurveReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: {
            customer_id: (data.customer === "All" || data.customer === undefined) ? null : data.customer,
            status_id: status.length > 0 ? status.toString() : null,
            customer_type_id: ptStatus && ptStatus.length > 0? ptStatus.toString(): "2,14,1,3,13",
            region_id: (data.region === "All" || data.region === undefined) ? null : data.region,
            from_date: moment(data?.from_date).format("MM-DD-YYYY"),
            to_date: moment(data?.to_date).format("MM-DD-YYYY"),
            cut_id: (data.cut === "All" || data.cut === undefined) ? null : data.cut,
            gender_id: (data.gender === "All" || data.gender === undefined) ? null : data.gender,
            style_id: (data.style === "All" || data.style === undefined) ? null : data.style,
            sku: (data.sku === "" || data.sku === undefined) ? null : data.sku,
            inseam_id: (data.inseam === "All" || data.inseam === undefined) ? null : data.inseam,
        }
    })
        .then((response) => {
            return dispatch({ type: GET_SIZE_CURVE_REPORT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_SIZE_CURVE_REPORT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_SIZE_CURVE_REPORT_ERROR,
                payload: error.response,
            });
        });
};